<!-- im社交系统 -->
<template>
  <div class="warp">
    <div class="knowledgePayBanner">
      <p>绿茶IM社交系统</p>
      <span>
        开启即时通讯时代，
        <br />自建IM社交生态
      </span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>

    <div class="social">
      <div class="title">
        <span>即时通讯</span>
      </div>
      <ul class="swiper-tab" id="myMenu">
        <li @click="changeTab(1)" :class="indexActive==1?'indexActive':''">
          <span>私密聊天</span>
          <i></i>
        </li>
        <li @click="changeTab(2)" :class="indexActive==2?'indexActive':''">
          <span>多元沟通</span>
          <i></i>
        </li>
        <li @click="changeTab(3)" :class="indexActive==3?'indexActive':''">
          <span>隐私安全</span>
          <i></i>
        </li>
      </ul>

      <swiper :options="swipersocial" ref="mySwiper">
        <!-- slides -->
        <swiper-slide class="swiper-item">
          <div class="box">
            <img src="../../assets/images/page32.jpg" />
            <div class="right">
              <span>私密聊天</span>
              <p>端对端加密聊天，单聊、群聊、讨论组，支持所有IM场景</p>
              <button>立即体验</button>
            </div>
          </div>
        </swiper-slide>

        <swiper-slide class="swiper-item">
          <div class="box">
            <img src="../../assets/images/page33.jpg" />
            <div class="right">
              <span>多元沟通</span>
              <p>支持文字、图片、表情、语音、文件、 红包等丰富多元的聊天方式，满足用户间 的及时沟通</p>
              <button>立即体验</button>
            </div>
          </div>
        </swiper-slide>

        <swiper-slide class="swiper-item">
          <div class="box">
            <img src="../../assets/images/page34.jpg" />
            <div class="right">
              <span>隐私安全</span>
              <p>加密个人信息、所有对话和共享文件， 联系时不必担心数据被拦截或窃取</p>
              <button>立即体验</button>
            </div>
          </div>
        </swiper-slide>

        <!-- Optional controls ,显示小点-->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <div class="social">
      <div class="title">
        <span>社群营销管理</span>
      </div>
      <div class="imgOneBox">
        <img src="../../assets/images/page35.jpg" />
      </div>
      <ul class="socialList1">
        <li>
          <img src="../../assets/images/icon45.png" />
          <div>
            <span>万人社群</span>
            <p>创建社群快速灵活，打破传统社群人数限制，轻松打造万人社群</p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/icon46.png" />
          <div>
            <span>社群管理</span>
            <p>
              支持群升级，根据需求扩充群人数限制；拥有丰富的权限及社群管
              理功能满足多人移动沟通需求
            </p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/icon47.png" />
          <div>
            <span>社群裂变</span>
            <p>
              主群可创建多个子群，主群内容可同步到所有子群；群口令、群链
              接、群二维码等推广形式，快速实现社群裂变
            </p>
          </div>
        </li>
      </ul>
    </div>

    <div class="social" style="background-color:#eff0f2;margin-top:.5rem;">
      <div class="title">
        <span>IM开放平台</span>
        <p>丰富的应用，满足多样化场景</p>
      </div>

      <ul class="socialList2">
        <li>
          <img src="../../assets/images/icon48.png" />
          <p>购物商城</p>
        </li>
        <li>
          <img src="../../assets/images/icon49.png" />
          <p>娱乐游戏</p>
        </li>
        <li>
          <img src="../../assets/images/icon50.png" />
          <p>互动直播</p>
        </li>
        <li>
          <img src="../../assets/images/icon51.png" />
          <p>行情资讯</p>
        </li>
        <li>
          <img src="../../assets/images/icon52.png" />
          <p>社群机器人</p>
        </li>
        <li>
          <img src="../../assets/images/icon53.png" />
          <p>营销工具</p>
        </li>
      </ul>
    </div>

    <div class="social">
      <div class="title">
        <span>IM平台优势</span>
        <p>快、省、稳定</p>
      </div>

      <ul class="socialList3">
        <li>
          <img src="../../assets/images/icon54.png" />
          <div>
            <span>稳定健壮</span>
            <p>采用动态智能DNS掉线快速重连机制，消息排重持续重连直至到达</p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/icon55.png" />
          <div>
            <span>亿级并发</span>
            <p>10年经验，稳定支撑多款亿级用户产品，亿级消息并发即时到达</p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/icon56.png" />
          <div>
            <span>全球多节点</span>
            <p>异地多机房服务集群覆盖全球范围，架构灵活支持水平自动伸缩</p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/icon57.png" />
          <div>
            <span>安全可靠</span>
            <p>采用私有二进制通讯协议及国密算法数据全程加密，安全可靠</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "socialSystem",

  data() {
    const vm = this;
    return {
      indexActive: 1,
      swipersocial: {
        // loop: true,
        speed: 500, //匀速时间
        pagination: {
          el: ".swiper-pagination"
        },
        on: {
          slideChangeTransitionEnd: function() {
            vm.indexActive = this.activeIndex + 1;
            // console.log(vm);
            // debugger;
          }
        }
      }
    };
  },
  mounted() {},

  methods: {
    changeTab(i) {
      this.$nextTick(function() {
        this.$refs.mySwiper.swiper.slideTo(i - 1, 500, false);
        this.indexActive = i;
      });
    }
  }
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .knowledgePayBanner {
    background: url("../../assets/images/socialSystemBanner.jpg") no-repeat left
      top;
    background-size: 100% auto;
    height: 7rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
    p {
      font-size: 0.6rem;
    }
    span {
      font-size: 0.36rem;
      line-height: 0.6rem;
      display: block;
      padding-top: 0.2rem;
    }
    a {
      background-color: #fff;
      width: 3rem;
      height: 0.9rem;
      text-align: center;
      color: #2d3e89;
      font-size: 0.36rem;
      border-radius: 0.9rem;
      margin-top: 0.5rem;
      line-height: .9rem;
      display: block;
    }
  }
  .social {
    .title {
      padding: 1rem 0 0.5rem;

      span {
        font-size: 0.48rem;
        display: block;
        text-align: center;
        font-weight: 500;
      }
      p {
        text-align: center;
        font-size: 0.34rem;
        padding: 0.2rem 0;
      }
    }
    .swiper-pagination {
      bottom: 0;
      .swiper-pagination-bullet {
        background-color: #dfe5fc;
      }
    }
    .swiper-tab {
      display: flex;
      li {
        flex: 1;
        font-size: 0.4rem;
        line-height: 1rem;
        text-align: center;
        position: relative;
      }
      .indexActive {
        i {
          width: 1.1rem;
          height: 2px;
          background-color: #2d3e89;
          display: block;
          position: absolute;
          margin-left: -0.55rem;
          left: 50%;
          bottom: 0.1rem;
          border-radius: 2px;
        }
      }
    }
    .swiper-item {
      .box {
        padding: 0.6rem 0.55rem 1rem;
        display: flex;
        box-sizing: border-box;
        align-items: center;
        img {
          width: 4.33rem;
          height: 3.33rem;
          margin-right: 0.7rem;
        }
        .right {
          span {
            font-size: 0.4rem;
            color: #223175;
          }
          p {
            font-size: 0.3rem;
            color: #666;
            line-height: 0.5rem;
            padding: 0.1rem 0;
          }
          button {
            width: 2.4rem;
            height: 0.8rem;
            border: 1px #fff solid;
            border-radius: 0.8rem;
            font-size: 0.36rem;
            color: #fff;
            background-color: #f7a23e;
            margin-top: 0.1rem;
          }
        }
      }
    }
  }
  .socialList1 {
    padding: 0 0.6rem;
    padding-bottom: 0.6rem;
    li {
      display: flex;
      padding: 0.3rem 0;
      img {
        width: 0.8rem;
        height: 0.8rem;
      }
      div {
        padding-left: 0.1rem;
        span {
          line-height: 0.8rem;
          color: #223175;
          font-size: 0.4rem;
        }
        p {
          font-size: 0.34rem;
          color: #666;
        }
      }
    }
  }
  .socialList2 {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 33.33333%;
      text-align: center;
      padding-bottom: 1rem;
      img {
        width: 1.78rem;
      }
      p {
        font-size: 0.34rem;
        padding-top: 0.3rem;
      }
    }
  }
  .socialList3 {
    padding:0 0.75rem;
    li {
      border-radius: .1rem;
      background-color: rgb(255, 255, 255);
      box-shadow: -0.558px 7.981px 18px 0px rgba(90, 109, 210, 0.18);
      position: relative;
      z-index: 10;
      margin-bottom: .65rem;
      padding: .38rem;
      display: flex;
      align-items: center;
      img{
          width: 1.77rem;
          height: 1.77rem;
      }
      div{
          flex: 1;
          padding: .2rem;
          span{
              font-size: .4rem;
              display: block;
              padding-bottom: .15rem;
          }
          p{
              font-size: .34rem;
              color: #666;
          }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/socialSystem.vue